import { InjectionToken } from '@angular/core';
export const CMS_PLATFORM_ORIGINS = new InjectionToken<readonly string[]>(
  'CMS_PLATFORM_ORIGINS',
  { providedIn: 'root', factory: () => ['http://localhost:4200'] }
);

export const CMS_COGNITO_CLIENT_IDS = new InjectionToken<readonly string[]>(
  'CMS_COGNITO_CLIENT_IDS',
  { providedIn: 'root', factory: () => [] }
);

export const CMS_BYPASS_GUARD = new InjectionToken<boolean>(
  'CMS_BYPASS_GUARD',
  { providedIn: 'root', factory: () => false }
);
